import axios from "axios";
import { getSession } from "../Utils/SessionUtils";

const api_url = process.env.REACT_APP_API;
const getAuthToken = () => {
  const token = localStorage.getItem("token");
  return token ? `Bearer ${token}` : "";
};
/* Setting the header for the axios request. */
const config = {
  headers: { Authorization: `Bearer ${getSession("token")}` },
};

const currentOrg = getSession("usedorganisations");

// Update addMenu function to include reference
// Update addMenu function to include readyToServe parameter
export async function addMenu(
  titre,
  description,
  info,
  image,
  category_id,
  prix,
  dispo,
  ordre,
  reference,
  prixHT,
  tauxTVA,
  organisation_id,
  unite,
  readyToServe,
  prix_quantite,
) {
  const frmData = new FormData();
  frmData.append("titre[fr]", titre.fr);
  frmData.append("titre[en]", titre.en);
  frmData.append("titre[ar]", titre.ar);
  frmData.append("description[fr]", description.fr);
  frmData.append("description[en]", description.en);
  frmData.append("description[ar]", description.ar);

  // Add reference if provided
  if (reference) {
    frmData.append("reference", reference);
  }

  // Add price fields
  frmData.append("prix_ttc", prix || 0);
  if (prixHT) {
    frmData.append("prix_ht", prixHT);
  }
  if (tauxTVA) {
    frmData.append("tva", parseFloat(tauxTVA));
  }

  // Add readyToServe field
  frmData.append("readyToServe", readyToServe || false);

  info.forEach((item) => {
    frmData.append(`info`, JSON.stringify(item));
  });

  for (let i = 0; i < image.length; i++) {
    frmData.append("image", image[i]);
  }

  // Clean the organisation_id before appending

  // Clean category_id if provided
  if (category_id) {
    const cleanCategoryId = category_id.replace(/['"]+/g, "").trim();
    frmData.append("category_id", cleanCategoryId);
  }

  frmData.append("prix", prix || 0);
  frmData.append("dispo", true);
  frmData.append("ordre", ordre);
  frmData.append("organisation_id", organisation_id);
  frmData.append("unite", unite);

  if (prix_quantite && prix_quantite > 0) {
    frmData.append("prix_quantite", prix_quantite);
  }

  const httpHeaders = {
    headers: {
      Authorization: `Bearer ${getSession("token")}`,
      "Content-Type": `multipart/form-data; boundary=${frmData._boundary}`,
    },
  };

  try {
    const response = await axios.post(api_url + "menu", frmData, httpHeaders);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
export async function importMenusFromExcel(formData) {
  // Check if formData is actually a FormData object
  if (!(formData instanceof FormData)) {
    throw new Error("Les données doivent être au format FormData.");
  }

  const httpHeaders = {
    headers: {
      Authorization: `Bearer ${getSession("token")}`,
      "Content-Type": "multipart/form-data",
    },
  };

  try {
    const response = await axios.post(
      api_url + "menu/import-excel",
      formData,
      httpHeaders,
    );
    return response;
  } catch (error) {
    console.error("Erreur lors de l'import Excel:", error);
    throw error;
  }
}
export async function editMenu(
  titre,
  description,
  info,
  image,
  prix_ht,
  prix_ttc,
  tva,
  seuil_alerte,
  reference,
  code_barre,
  poids,
  dispo,
  readyToServe,
  ordre,
  id,
  org,
  sous_categories,
  category_id, // Ensure this matches the new argument from onSubmit
) {
  const frmData = new FormData();

  // Basic Identifiers
  frmData.append("id", id);
  frmData.append("organisation_id", org);
  if (category_id) frmData.append("category_id", category_id);

  // Multilingual Fields
  frmData.append("titre[fr]", titre.fr || "");
  frmData.append("titre[en]", titre.en || "");
  frmData.append("titre[ar]", titre.ar || "");
  frmData.append("description[fr]", description.fr || "");
  frmData.append("description[en]", description.en || "");
  frmData.append("description[ar]", description.ar || "");

  // Financials & Stock
  frmData.append("prix_ht", prix_ht || 0);
  frmData.append("prix_ttc", prix_ttc || 0);
  frmData.append("tva", tva || 0);
  frmData.append("seuil_alerte", seuil_alerte || 0);
  frmData.append("ordre", ordre || 1);

  // Identification
  frmData.append("reference", reference || "");
  frmData.append("code_barre", code_barre || "");
  frmData.append("poids", poids || 0);

  // Boolean Logic: Stringify so the API receives "true"/"false"
  frmData.append("dispo", String(dispo));
  frmData.append("readyToServe", String(readyToServe));

  // Complex Types (Arrays/Files)
  if (info) {
    info.forEach((item) => frmData.append("info", JSON.stringify(item)));
  }

  if (image && image.length > 0) {
    for (let i = 0; i < image.length; i++) {
      if (image[i] instanceof File) {
        frmData.append("image", image[i]);
      }
    }
  }

  if (sous_categories && sous_categories.length > 0) {
    sous_categories.forEach((catId) => {
      frmData.append("sous_categories[]", catId);
    });
  }

  const httpHeaders = {
    headers: {
      Authorization: `Bearer ${getSession("token")}`,
      "Content-Type": "multipart/form-data",
    },
  };

  try {
    return await axios.patch(api_url + "menu", frmData, httpHeaders);
  } catch (error) {
    console.error("API Service Error:", error);
    throw error;
  }
}
export async function getMenus(id, page = 1, limit = 12, search = "") {
  if (id === null) {
    id = currentOrg;
  }
  try {
    // Added search parameter to the URL
    const response = await axios.get(
      `${api_url}menu/organisation/${id}?page=${page}&limit=${limit}&search=${search}`,
      config,
    );
    return response;
  } catch (error) {
    console.error(error);
  }
}
// Fix 1: Function should accept two parameters, not an object
export async function getProductByBarCode({ barcode, organisation }) {
  if (organisation === null) {
    organisation = currentOrg;
  }

  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };

  try {
    const response = await axios.get(
      `${api_url}menu/findByBarcode/${organisation}/${barcode}`,
      config,
    );
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
// Quick product creation from the POS (barcode scanned but not found)
export async function createQuickMenu({
  categorie,
  code_barre,
  libelle,
  prix,
  organisation_id,
}) {
  const httpHeaders = {
    headers: { Authorization: `Bearer ${getSession("token")}` },
  };
  const response = await axios.post(
    `${api_url}menu/quick-create`,
    { categorie, code_barre, libelle, prix, organisation_id },
    httpHeaders,
  );
  return response;
}

// Persist a price/remise edit made from the POS to the product's catalog
// entry (as opposed to a one-off override on the current cart line only).
export async function updateProductQuickFields({ id, prix_ttc, remise }) {
  const httpHeaders = {
    headers: { Authorization: `Bearer ${getSession("token")}` },
  };
  const response = await axios.patch(
    `${api_url}menu/quick-update`,
    { id, prix_ttc, remise },
    httpHeaders,
  );
  return response;
}

export async function findAll(id) {
  try {
    const response = await axios.get(`${api_url}menu/findAll/${id}`, config);
    return response;
  } catch (error) {
    console.error(error);
  }
}
export const createRaccourci = async (data) => {
  return await axios.post(`${api_url}menu/raccourci`, data, {
    headers: {
      Authorization: getAuthToken(),
      "Content-Type": "application/json",
    },
  });
};
export const getRaccourcisByOrganisation = async (
  organisationId,
  raccourciName = null,
) => {
  try {
    const token = localStorage.getItem("token");
    let url = `${api_url}menu/raccourci/organisation/${organisationId}`;

    if (raccourciName) {
      url += `?raccourci_name=${encodeURIComponent(raccourciName)}`;
    }

    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching raccourcis:", error);
    throw error;
  }
};
export const getRaccourcisByid = async (id, raccourciName = null) => {
  try {
    const token = localStorage.getItem("token");
    let url = `${api_url}menu/raccourci/${id}`;

    if (raccourciName) {
      url += `?raccourci_name=${encodeURIComponent(raccourciName)}`;
    }

    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching raccourcis:", error);
    throw error;
  }
};
export const updateRaccourci = async (raccourciName, updateData) => {
  try {
    const token = localStorage.getItem("token");
    const url = `${api_url}menu/raccourci/${encodeURIComponent(raccourciName)}`;

    const response = await axios.put(url, updateData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error updating raccourci:", error);
    throw error;
  }
};
export async function getMenusreadyToServe(id, params = {}) {
  if (id === null) {
    id = currentOrg;
  }
  try {
    const response = await axios.get(api_url + "menu/readyToServe/" + id, {
      ...config,
      params,
    });
    return response;
  } catch (error) {
    console.error(error);
  }
}
export async function getMenusByOrg(id) {
  try {
    const response = await axios.get(
      api_url + "menu/organisation/" + id,
      config,
    );
    return response;
  } catch (error) {
    console.error(error);
  }
}

export async function getMenuById(id) {
  try {
    const response = await axios.get(api_url + "menu/" + id, config);
    return response;
  } catch (error) {
    console.error(error);
  }
}

export async function deleteMenu(id) {
  try {
    const response = await axios.delete(api_url + "menu/" + id, config);
    return response;
  } catch (error) {
    console.error(error);
  }
}

export async function getMenuByCategoryId(id) {
  try {
    const response = await axios.get(api_url + "menu/categories/" + id, config);
    return response;
  } catch (error) {
    console.error(error);
  }
}

export async function getMenuByCarteId(id_org, id) {
  try {
    const response = await axios.get(
      api_url + "menu/carte/" + id_org + "/" + id,
    );
    return response;
  } catch (error) {
    console.error(error);
  }
}
export const saveInventoryToAPI = async (inventoryData) => {
  return await axios.post(`${api_url}menu/inventories`, inventoryData, {
    headers: {
      Authorization: getAuthToken(),
      "Content-Type": "application/json",
    },
  });
};

export async function getInventories(
  organisationId = null,
  {
    page = 1,
    limit = 20,
    search = "",
    date_debut = "",
    date_fin = "",
    completed = "",
  } = {},
) {
  const id = organisationId || currentOrg;

  try {
    const params = {
      page,
      limit,
    };

    if (search) params.search = search;
    if (date_debut) params.date_debut = date_debut;
    if (date_fin) params.date_fin = date_fin;
    if (completed !== "") params.completed = completed;

    const response = await axios.get(
      `${api_url}menu/inventories/organisation/${id}`,
      {
        ...config,
        params, // send query params
      },
    );

    return response.data; // return only data for easier usage
  } catch (error) {
    console.error("Error fetching inventories:", error);
    return { success: false, data: [], error: error.message };
  }
}

// Services/MenuApi.js - Ajoutez cette fonction
export const completeInventory = async (inventoryId, data) => {
  try {
    const response = await axios.put(
      api_url + `menu/complete_inventories/${inventoryId}`,
      data,
      {
        headers: {
          Authorization: getAuthToken(),
          "Content-Type": "application/json",
        },
      },
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const getMouvements = async (organisationId, filters = {}) => {
  try {
    const params = new URLSearchParams();

    // Add filters to params
    Object.keys(filters).forEach((key) => {
      if (filters[key]) {
        params.append(key, filters[key]);
      }
    });

    const response = await axios.get(
      api_url + `menu/mouvements/${organisationId}?${params.toString()}`,
      {
        headers: {
          Authorization: getAuthToken(),
          "Content-Type": "application/json",
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
// Add this function to your MenuApi service
export const updateInventory = async (inventoryId, inventoryData) => {
  try {
    const response = await axios.put(
      api_url + `menu/updateInventory/${inventoryId}`,
      inventoryData, // 1. Pass the actual data payload as the 2nd argument
      {
        headers: {
          // 2. Pass the headers config as the 3rd argument
          Authorization: getAuthToken(),
          "Content-Type": "application/json",
        },
      },
    );
    return response;
  } catch (error) {
    console.error("Error updating inventory:", error);
    throw error;
  }
};
// Lightweight, reusable product search for dropdowns/pickers.
export const searchProducts = async (organisationId, params = {}) => {
  try {
    const response = await axios.get(
      `${api_url}menu/products/search/${organisationId}`,
      {
        headers: {
          Authorization: getAuthToken(),
          "Content-Type": "application/json",
        },
        params,
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error searching products:", error);
    return { success: false, data: [] };
  }
};
